import { createSlice, PayloadAction, createSelector } from 'redux-starter-kit';
import { Mutations, Resources } from '@erecruit/types';

import { selectAppState } from '../../../App/state/selectors';
import { PositionTemplate } from '../../AddNewPositionWizard/types';

export interface RequestPositionPayload {
  positionTemplates: Resources.PositionTemplate[];
}

export interface RequestPositionState extends RequestPositionPayload {
  isLoading: boolean;
  error?: string;
  populatedPositionTemplate?: PositionTemplate;
  positionId?: number;
  companies: Resources.Company[];
  selectedCompany: number;
}

const initialState: RequestPositionState = {
  isLoading: false,
  positionTemplates: [],
  companies: [],
  selectedCompany: -1,
};

const RequestPositionSlice = createSlice({
  slice: 'requestPosition',
  initialState: initialState,
  reducers: {
    resetPositionTemplate() {
      return { ...initialState };
    },
    clearPositionTemplateDetails(state) {
      state.populatedPositionTemplate = undefined;
    },
    requestPositionTemplates(
      state,
      // eslint-disable-next-line
      action: PayloadAction<{ searchTerm: string; companyId: number }>,
    ) {
      state.isLoading = true;
    },
    requestPositionTemplatesSuccess(
      state,
      action: PayloadAction<RequestPositionPayload>,
    ) {
      state.isLoading = false;
      state.positionTemplates = action.payload.positionTemplates;
    },
    setSelectedCompany(state, action: PayloadAction<number>) {
      state.selectedCompany = action.payload;
    },
    requestPositionTemplatesFail(state, action: PayloadAction<string>) {
      state.error = action.payload;
      state.isLoading = false;
    },
    fetchCompanies() {},
    fetchCompaniesSuccess(state, action: PayloadAction<Resources.Company[]>) {
      state.companies = action.payload;
    },
    requestPositionTemplateDetails(
      state,
      // eslint-disable-next-line
      action: PayloadAction<Resources.PositionTemplate>,
    ) {
      state.isLoading = true;
    },
    requestPositionTemplateDetailsSuccess(
      state,
      action: PayloadAction<PositionTemplate>,
    ) {
      state.populatedPositionTemplate = action.payload;
      state.isLoading = false;
      return state;
    },
    requestPositionTemplateDetailsFail(state, action: PayloadAction<string>) {
      state.error = action.payload;
      state.isLoading = false;
    },
    savePosition(
      state,
      // eslint-disable-next-line
      action: PayloadAction<Mutations.NewPositionParams>,
    ) {
      state.isLoading = true;
    },
    savePositionFail(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = action.payload;
    },
    savePositionSuccess(
      state,
      { payload: [{ id }] }: PayloadAction<[{ id: number }]>,
    ) {
      state.isLoading = false;
      state.positionId = id;
    },
    resetPosition() {
      return { ...initialState };
    },
  },
});

const {
  actions,
  reducer,
  selectors: { getRequestPosition },
} = RequestPositionSlice;

export const {
  resetPositionTemplate,
  requestPositionTemplates,
  requestPositionTemplatesFail,
  requestPositionTemplatesSuccess,
  requestPositionTemplateDetails,
  requestPositionTemplateDetailsFail,
  requestPositionTemplateDetailsSuccess,
  resetPosition,
  savePosition,
  savePositionFail,
  savePositionSuccess,
  fetchCompaniesSuccess,
  fetchCompanies,
  setSelectedCompany,
  clearPositionTemplateDetails,
} = actions;
export const selectors = {
  selectRequestPositionState: createSelector(
    [selectAppState],
    getRequestPosition,
  ),
};
export default reducer;
